<p-breadcrumb class="max-w-full" styleClass="pb-0" [model]="menuItems">
  <ng-template #separator> / </ng-template>
</p-breadcrumb>
@if (loadFailed) {
  <div class="flex flex-col items-center gap-(--gap-normal) py-16 text-(--text-secondary)">
    <ces-icon size="xl" containerSize="md">person_off</ces-icon>
    <p>{{ 'entities.user.messages.notFound' | transloco }}</p>
    <ces-button [label]="'entities.user.breadcrumb' | transloco" icon="arrow_back" (onClick)="goBackToUsers()" />
  </div>
} @else {
  <div class="pl-(--space-4) flex flex-col">
    <div class="flex justify-between mb-(--space-12)">
      <div class="flex flex-col">
        <h1 class="mb-(--space-3)">{{ user.firstname }} {{ user.name }}</h1>
        <div class="flex flex-col text-sm font-normal text-(color:--text-secondary)">
          <span class="flex items-center gap-x-1"><ces-icon containerSize="xs">corporate_fare</ces-icon> {{ user.company }}</span>
          @if (user.email) {
            <a class="flex items-center gap-x-1" href="mailto:{{ user.email }}"
              ><ces-icon containerSize="xs">mail</ces-icon> {{ user.email }}</a
            >
          }
          @if (user.phone) {
            <span class="flex items-center gap-x-1"><ces-icon containerSize="xs">call</ces-icon> {{ user.phone }}</span>
          }
          <span class="flex items-center gap-x-1"
            ><ces-icon containerSize="xs">schedule</ces-icon> {{ 'entities.user.lastConnection' | transloco }}
            {{ user.lastLoggedOn | date: 'dd.MM.yyyy HH:mm' }}</span
          >
        </div>
      </div>
      <div class="flex gap-(--gap-normal)">
        <ces-button [label]="'common.buttons.add' | transloco" icon="add" (onClick)="createAccessRight()" />
      </div>
    </div>
    <div class="pl-(--space-4) flex flex-col">
      <h2>{{ 'entities.access.plural' | transloco }}</h2>
      <ces-generic-parent-grid
        (editEntity)="editAccessRight($event)"
        [dataLoadingCompleted]="dataLoadingCompleted"
        [entities]="accessRightsDomain"
        [entityDefinition]="accessRightDefinition"
        [selectionMode]="'multiple'"
        [selectedEntityIds]="selectedAccessRightIds"
        (selectionChange)="onSelectionChange($event)" />
    </div>
  </div>
}

@if (showBulkEditButton) {
  <div class="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-50">
    <div
      class="flex flex-row gap-(--gap-relaxed) border border-(--border) bg-(--surface-0) p-(--space-3) rounded-(--radius-lg) shadow-lg">
      <ces-button-tertiary [label]="'common.buttons.cancel' | transloco" (onClick)="cancelBulkEdit()" />
      <span class="flex items-center text-sm font-medium text-(color:--text-secondary)">
        {{ 'common.messages.itemsSelected' | transloco: { count: selectedAccessRightIds.length } }}
      </span>
      <ces-button-tertiary [label]="'common.buttons.delete' | transloco" icon="delete" (onClick)="bulkDeleteAccessRights()" />
      <ces-button [label]="'common.buttons.edit' | transloco" icon="edit" (onClick)="bulkEditAccessRights()" />
    </div>
  </div>
}
